import { tap } from 'lodash/fp';

export const log = tap(window.console.log);